import { Paper, Tooltip } from '@mui/material';
import { ColumnHeaderFilterIconButtonProps } from '@mui/x-data-grid';
import React, { useEffect, useState, Children, ReactElement, ReactNode  } from 'react';

export interface Props {
    header: string;
    children:  ReactElement | ReactNode;
    tooltipText?: string;
}

const TableContainer = ({header, children, tooltipText=""}:Props) => {
    return <Paper elevation={5} style={{padding: "0.25rem"}}>
        {tooltipText !== '' ? <Tooltip title={tooltipText}>
        <h4 style={{padding: "1rem", margin: "0", width: '40%'}}>{header}</h4>    
        </Tooltip> : <h4 style={{padding: "1rem", margin: "0"}}>{header}</h4>}
        {children}
    </Paper>
}

export default TableContainer;